import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface ApplyCouponToCartMutationObject {
  mutation: {
    applyCouponToCart: {
      __args: {
        input: {
          cart_id: string
          coupon_code: string
          [key: string]: any
        }
      }
      [key: string]: any
    }
  }
}

export const applyCouponToCartMutationObject = {
  mutation: {
    applyCouponToCart: {
      __args: {
        input: {
          cart_id: '',
          coupon_code: ''
        }
      }
    }
  }
}

interface ApplyCouponToCartMutationInput {
  cartId: string
  couponCode: string
}

export type ApplyCouponToCartMutation = (input: ApplyCouponToCartMutationInput) => Promise<FetchResult<any>>

export const createApplyCouponToCartMutation = ({ getMutations, getQueries }: ServiceDependencies): ApplyCouponToCartMutation => async ({ cartId, couponCode }) => {
  const queries = getQueries()
  const mutation = getMutations().applyCouponToCartMutation
  mutation.mutation.applyCouponToCart.__args.input.cart_id = cartId
  mutation.mutation.applyCouponToCart.__args.input.coupon_code = couponCode
  mutation.mutation.applyCouponToCart = {
    ...mutation.mutation.applyCouponToCart,
    cart: {
      ...queries.cartQuery,
      ...queries.cartPrices,
      ...queries.shippingAddresses, // TODO: implement `withSelectedShippingMethod (selected_shipping_method)` and remove the ignore: true
      ...queries.billingAddresses,
      ...queries.cartAppliedCoupon
    }
  }

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`,
    fetchPolicy: 'no-cache'
  })
}
